export function createParagraphNode({ text }) {
  return {
    type: 'p',
    children: [{ text }],
  }
}
